export function failSafeParseJSON<T = unknown, TFallback = undefined>(
  jsonString: string | undefined,
  fallback?: TFallback
): T | TFallback {
  if (typeof jsonString === 'string') {
    try {
      return JSON.parse(jsonString);
    } catch (_e) {
      try {
        const sanitized = jsonString.replace(/,\s*([}\]])/g, '$1');
        return JSON.parse(sanitized);
      } catch (_e2) {
        // unparseable JSON
      }
    }
  }

  return fallback as TFallback;
}
